/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Output } from '@angular/core';
import { CartPurchaseService } from '../utils-components/cart/cart-purchase.service';
import { ISettingsTable } from 'src/app/@amiga-pyme/interfaces/table.interface';
import { PurchasesService } from '../purchases.service';
import { DocumentSettingService } from '../document-setting/document-setting.service';
import { ProviderSelectionService } from '../provider-selection/provider-selection.service';
import { IDialogMessage } from 'src/app/@amiga-pyme/components/ami-dialog-message/ami-dialog-message.interface';
import { TokenService } from 'src/app/auth/services/token/token.service';
import { IDocumentSettings, IEventPurchase } from '../purchases.interface';
import { IProvider } from 'src/app/pages/gestion/providers/provider.interface';

const ID_VOUCHER_BY_NAME = {
  BOLETA: 1,
  FACTURA: 2,
  NOTA_VENTA: 3
};

@Component({
  selector: 'pg-purchase-confirmation-selection',
  templateUrl: './confirmation.component.html'
})
export class ConfirmationComponent {
  @Output('stepsEmitter') stepsEmitter = new EventEmitter<IEventPurchase>();

  table: { settings: ISettingsTable; data: any[]; actions: any } = {
    settings: {
      title: '',
      columns: []
    },
    data: [],
    actions: null
  };
  products: any[];
  eventMessage = {
    action: 'nextPage',
    data: null
  };

  providerSelected: IProvider;
  message: IDialogMessage;
  documentDetails = {} as IDocumentSettings;
  selectedColumns: unknown[];
  totalMoney = this.cartPurchaseService.getAmountPurchase();

  constructor(
    private tokenService: TokenService,
    private cartPurchaseService: CartPurchaseService,
    private purchasesService: PurchasesService,
    private documentSettingService: DocumentSettingService,
    private providerSelectionService: ProviderSelectionService
  ) {}

  ngOnInit() {
    this.table.settings = {
      title: 'Productos seleccionados',
      columns: [
        { header: 'Proveedor', field: 'providerName' },
        { header: 'Unidad de medida', field: 'unitMeasureDescription' },
        { header: 'Código', field: 'code' },
        { header: 'Descripción', field: 'description' },
        { header: 'Cantidad', field: 'quantityCart' },
        { header: 'Precio unitario', field: 'unitPrice' },
        { header: 'Lote', field: 'lot' }
      ]
    };
    this.table.actions = null;

    this.providerSelected = this.providerSelectionService.data;
    this.documentDetails = this.documentSettingService.data;
    this.cartPurchaseService.getData$().subscribe((data) => {
      this.products = data;
      this.table.data = this.products;
      this.totalMoney = this.cartPurchaseService.getAmountPurchase();
    });
  }

  async confirmOperation() {
    const requestAPI: object = this.buildRequestApi();
    this.message = { message: 'Registrando compra' };
    this.message = await this.purchasesService.register(requestAPI);

    const status = this.message.status;
    if (status === 201) {
      setTimeout(() => {
        this.cartPurchaseService.emptyData();
        this.documentSettingService.emptyData();
        this.providerSelectionService.emptyData();

        this.stepsEmitter.emit({
          action: 'success_purchase',
          data: null
        } as IEventPurchase);
      }, 1500);
    }
  }

  buildRequestApi(): object {
    const requestAPI = {
      document: {
        providerId: this.providerSelected['id'],
        typeVoucherId: ID_VOUCHER_BY_NAME[this.documentDetails['documentType']],
        amount: this.totalMoney,
        numberDocument: this.documentDetails['documentCode'],
        invoiceDate: this.buildInvoiceDateTime()
      },
      details: this.products.map((product) => ({
        productOfProviderId: product.id,
        quantity: product.quantityCart,
        lot: product.lot,
        expAt: product.expDate,
        purchasePrice: product.unitPrice
      }))
    };
    return requestAPI;
  }

  private buildInvoiceDateTime(): string {
    const date = this.documentDetails['date'];
    const time = this.documentDetails['time'];

    if (!date || !time) return date;

    const timeWithSeconds = time.length === 5 ? `${time}:00` : time;
    return `${date}T${timeWithSeconds}`;
  }

  prevPage() {
    this.stepsEmitter.emit({
      action: 'prev',
      data: null
    } as IEventPurchase);
  }
}
